var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
define('safe-mode',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var safeModeURL;
    (function (safeModeURL) {
        safeModeURL["master"] = "https://master-safemode.snappet.org";
        safeModeURL["production"] = "https://safemode.snappet.org";
    })(safeModeURL || (safeModeURL = {}));
    var LogType;
    (function (LogType) {
        LogType["Debug"] = "log";
        LogType["Warning"] = "warn";
        LogType["Error"] = "error";
    })(LogType || (LogType = {}));
    var Application;
    (function (Application) {
        Application["Pupil"] = "pupil";
        Application["Teacher"] = "teacher";
    })(Application || (Application = {}));
    var Environment;
    (function (Environment) {
        Environment["Production"] = "production";
        Environment["Master"] = "master";
    })(Environment || (Environment = {}));
    var SafeMode = /** @class */ (function () {
        function SafeMode() {
            this.safeModeSettings = new SafeModeSettings();
            this.localstoragePrefix = 'snappet-safemode-';
            this.localStorageCountryKey = 'countryId';
            this.localStorageSubjectKey = 'subjectId';
            this.localStorageGradeKey = 'grade';
            this.localStorageCourseKey = 'courseId';
            this.localStorageSectionKey = 'sectionId';
            this.localStorageLessonKey = 'lessonId';
            this.localStorageExerciseKey = 'exerciseId';
        }
        Object.defineProperty(SafeMode.prototype, "safeModeApplicationUrl", {
            get: function () {
                var countryId = localStorage.getItem("" + this.localstoragePrefix + this.localStorageCountryKey);
                var subjectId = localStorage.getItem("" + this.localstoragePrefix + this.localStorageSubjectKey);
                var grade = localStorage.getItem("" + this.localstoragePrefix + this.localStorageGradeKey);
                var courseId = localStorage.getItem("" + this.localstoragePrefix + this.localStorageCourseKey);
                var sectionId = localStorage.getItem("" + this.localstoragePrefix + this.localStorageSectionKey);
                var lessonId = localStorage.getItem("" + this.localstoragePrefix + this.localStorageLessonKey);
                var exerciseId = localStorage.getItem("" + this.localstoragePrefix + this.localStorageExerciseKey);
                var isFirstParam = true;
                var url = this.options.url + "/" + this.options.applicationType;
                if (countryId) {
                    url = this.formatUrl(url, isFirstParam, "countryId=" + countryId);
                    isFirstParam = false;
                }
                if (subjectId) {
                    url = this.formatUrl(url, isFirstParam, "subjectId=" + subjectId);
                    isFirstParam = false;
                }
                if (grade) {
                    url = this.formatUrl(url, isFirstParam, "grade=" + grade);
                    isFirstParam = false;
                }
                if (courseId) {
                    url = this.formatUrl(url, isFirstParam, "courseId=" + courseId);
                    isFirstParam = false;
                }
                if (sectionId) {
                    url = this.formatUrl(url, isFirstParam, "sectionId=" + sectionId);
                    isFirstParam = false;
                }
                if (lessonId) {
                    url = this.formatUrl(url, isFirstParam, "lessonId=" + lessonId);
                    isFirstParam = false;
                }
                if (exerciseId) {
                    url = this.formatUrl(url, isFirstParam, "exerciseId=" + exerciseId);
                    isFirstParam = false;
                }
                return url;
            },
            enumerable: true,
            configurable: true
        });
        SafeMode.prototype.init = function (options) {
            if (this.options) {
                this.logMessage(LogType.Warning, 'SnappetSafeMode::init::snappet safe mode package is already initialized');
                return;
            }
            this.options = new SafeModeOptions(options);
            if (!this.options.applicationType) {
                this.logMessage(LogType.Error, "SnappetSafeMode::init::'applicationType' is a required parameter, please provide '" + Application.Pupil + "' or '" + Application.Teacher + "'");
                delete this.options;
                return;
            }
            if (!this.options.environment) {
                this.logMessage(LogType.Error, "SnappetSafeMode::init::'environment' is a required parameter, please provide '" + Environment.Production + "' or '" + Environment.Master + "'");
                delete this.options;
                return;
            }
            if (!this.options.disablePolling) {
                this.repeatedlyCheckIfSafeModeIsActive();
            }
        };
        SafeMode.prototype.check = function () {
            return __awaiter(this, void 0, void 0, function () {
                var safeModeSettings, err_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, this.checkIsInSafeMode()];
                        case 1:
                            safeModeSettings = _a.sent();
                            this.notifyEnabledOrDisabled(this.safeModeSettings.enabled, safeModeSettings.enabled, undefined);
                            this.notifyEnabledOrDisabled(this.safeModeSettings.appEnabled, safeModeSettings.appEnabled, Application.Pupil);
                            this.notifyEnabledOrDisabled(this.safeModeSettings.dashboardEnabled, safeModeSettings.dashboardEnabled, Application.Teacher);
                            this.safeModeSettings = safeModeSettings;
                            return [3 /*break*/, 3];
                        case 2:
                            err_1 = _a.sent();
                            this.logMessage(LogType.Error, 'SnappetSafeMode::check::an error occurred while updating safe mode status', [err_1]);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        SafeMode.prototype.setCountryId = function (id) {
            var key = "" + this.localstoragePrefix + this.localStorageCountryKey;
            this.updateLocalStorage(key, id);
        };
        SafeMode.prototype.setSubjectId = function (id) {
            var key = "" + this.localstoragePrefix + this.localStorageSubjectKey;
            this.updateLocalStorage(key, id);
        };
        SafeMode.prototype.setGrade = function (id) {
            var key = "" + this.localstoragePrefix + this.localStorageGradeKey;
            this.updateLocalStorage(key, id);
        };
        SafeMode.prototype.setCourseId = function (id) {
            var key = "" + this.localstoragePrefix + this.localStorageCourseKey;
            this.updateLocalStorage(key, id);
        };
        SafeMode.prototype.setSectionId = function (id) {
            var key = "" + this.localstoragePrefix + this.localStorageSectionKey;
            this.updateLocalStorage(key, id);
        };
        SafeMode.prototype.setLessonId = function (id) {
            var key = "" + this.localstoragePrefix + this.localStorageLessonKey;
            this.updateLocalStorage(key, id);
        };
        SafeMode.prototype.setExerciseId = function (id) {
            var key = "" + this.localstoragePrefix + this.localStorageExerciseKey;
            this.updateLocalStorage(key, id);
        };
        SafeMode.prototype.notifyEnabledOrDisabled = function (currentState, newState, applicationType) {
            if (currentState !== newState) {
                var enableDisableCallback = newState ? this.options.onEnabled : this.options.onDisabled;
                enableDisableCallback(applicationType);
                if (this.options.applicationType === applicationType) {
                    var showHideCallback = newState ? this.options.onShow : this.options.onHide;
                    showHideCallback();
                }
            }
        };
        SafeMode.prototype.updateLocalStorage = function (key, value) {
            if (!value && value !== 0) {
                localStorage.removeItem(key);
                return;
            }
            localStorage.setItem(key, value.toString());
        };
        SafeMode.prototype.checkIsInSafeMode = function () {
            return __awaiter(this, void 0, void 0, function () {
                var settingsUrl, response, err_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            settingsUrl = "" + this.options.url + this.options.configPath;
                            return [4 /*yield*/, this.httpGet(settingsUrl)];
                        case 1:
                            response = _a.sent();
                            return [2 /*return*/, new SafeModeSettings(response)];
                        case 2:
                            err_2 = _a.sent();
                            this.logMessage(LogType.Error, 'SnappetSafeMode::checkIsInSafeMode::an error occurred while checking safe mode', [err_2]);
                            return [2 /*return*/, new SafeModeSettings()];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        SafeMode.prototype.httpGet = function (url) {
            return new Promise(function (resolve, reject) {
                var request = new XMLHttpRequest();
                request.onload = function () {
                    if (request.status === 200) {
                        var response = request.response || '';
                        try {
                            var data = JSON.parse(response);
                            resolve(data);
                        }
                        catch (err) {
                            reject(new Error("error while trying to parse JSON response"));
                        }
                    }
                    else {
                        reject(new Error(request.statusText));
                    }
                };
                request.onerror = function () {
                    reject(new Error("SnappetSafeMode::httpGet::error: " + request.statusText));
                };
                request.open('GET', url);
                request.send();
            });
        };
        SafeMode.prototype.repeatedlyCheckIfSafeModeIsActive = function () {
            var _this = this;
            var interval = this.options.checkTimeoutSec * 1000;
            this.check();
            setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.check()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); }, interval);
        };
        SafeMode.prototype.formatUrl = function (url, isFirstParam, param) {
            if (isFirstParam) {
                url = url + "?" + param;
            }
            else {
                url = url + "&" + param;
            }
            return url;
        };
        SafeMode.prototype.logMessage = function (type, message, optionalParams) {
            if (optionalParams === void 0) { optionalParams = []; }
            if (this.options.isDebugEnabled) {
                console[type].apply(console, [message].concat(optionalParams));
            }
        };
        return SafeMode;
    }());
    var SafeModeOptions = /** @class */ (function () {
        function SafeModeOptions(options) {
            if (options === void 0) { options = {}; }
            if (options.environment
                && (options.environment === Environment.Production || options.environment === Environment.Master)) {
                this.environment = options.environment;
                this.url = safeModeURL[options.environment];
            }
            if (options.applicationType
                && (options.applicationType === Application.Pupil || options.applicationType === Application.Teacher)) {
                this.applicationType = options.applicationType;
            }
            this.checkTimeoutSec = options.checkTimeoutSec || 15;
            this.isDebugEnabled = options.isDebugEnabled || false;
            this.onShow = options.onShow || (function () { });
            this.onHide = options.onHide || (function () { });
            this.onEnabled = options.onEnabled || (function (_) { });
            this.onDisabled = options.onDisabled || (function (_) { });
            this.disablePolling = options.disablePolling || false;
            this.configPath = options.configPath || '/safe-mode/config/settings.json';
        }
        return SafeModeOptions;
    }());
    var SafeModeSettings = /** @class */ (function () {
        function SafeModeSettings(settings) {
            if (settings === void 0) { settings = {}; }
            this.enabled = !!settings.enabled;
            this.dashboardEnabled = !!settings.dashboardEnabled && this.enabled;
            this.appEnabled = !!settings.appEnabled && this.enabled;
            this.devicesEnabled = !!settings.devicesEnabled && this.enabled;
        }
        return SafeModeSettings;
    }());
    var safeMode = new SafeMode();
    exports.safeMode = safeMode;
});

